module.exports = __webpack_public_path__ + "static/media/Hover_playnow.7edfba5e.png";